module.exports={
	"Form": "PhysicalAssetDefectEditManifest",
	"Scope": "PhysicalAssetDefect-Edit",
	"Descriptors":
	{
		"PhysicalAssetDefectDetails.Code":
		{
			"Name": "Code",
			"Hash": "PhysicalAssetDefect-Edit-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetDefect-Edit-Identity",
				"Group": "PhysicalAssetDefect-Edit-Identity"
			}
		},
		"PhysicalAssetDefectDetails.Name":
		{
			"Name": "Name",
			"Hash": "PhysicalAssetDefect-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "PhysicalAssetDefect-Edit-Identity",
				"Group": "PhysicalAssetDefect-Edit-Identity"
			}
		},
		"PhysicalAssetDefectDetails.Description":
		{
			"Name": "Description",
			"Hash": "PhysicalAssetDefect-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "PhysicalAssetDefect-Edit-Details",
				"Group": "PhysicalAssetDefect-Edit-Details"
			}
		},
		"PhysicalAssetDefectDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "PhysicalAssetDefect-Edit-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "PhysicalAssetDefect-Edit-Details",
				"Group": "PhysicalAssetDefect-Edit-Details"
			}
		},
		"PhysicalAssetDefectDetails.PrimaryDocumentationURL":
		{
			"Name": "Primary Documentation URL",
			"Hash": "PhysicalAssetDefect-Edit-PrimaryDocumentationURL",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetDefect-Edit-Details",
				"Group": "PhysicalAssetDefect-Edit-Details"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS1":
		{
			"Name": "Good (CS1)",
			"Hash": "PhysicalAssetDefect-Edit-StateDescriptionCS1",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "5",
				"Width": 6,
				"Section": "PhysicalAssetDefect-Edit-ConditionStates",
				"Group": "PhysicalAssetDefect-Edit-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS2":
		{
			"Name": "Fair (CS2)",
			"Hash": "PhysicalAssetDefect-Edit-StateDescriptionCS2",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "5",
				"Width": 6,
				"Section": "PhysicalAssetDefect-Edit-ConditionStates",
				"Group": "PhysicalAssetDefect-Edit-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS3":
		{
			"Name": "Poor (CS3)",
			"Hash": "PhysicalAssetDefect-Edit-StateDescriptionCS3",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "6",
				"Width": 6,
				"Section": "PhysicalAssetDefect-Edit-ConditionStates",
				"Group": "PhysicalAssetDefect-Edit-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS4":
		{
			"Name": "Severe (CS4)",
			"Hash": "PhysicalAssetDefect-Edit-StateDescriptionCS4",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "6",
				"Width": 6,
				"Section": "PhysicalAssetDefect-Edit-ConditionStates",
				"Group": "PhysicalAssetDefect-Edit-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.IDPhysicalAssetDefect":
		{
			"Name": "IDPhysical Asset Defect",
			"Hash": "PhysicalAssetDefect-Edit-IDPhysicalAssetDefect",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAssetDefect-Edit-DataAudit",
				"Group": "PhysicalAssetDefect-Edit-DataAudit"
			}
		},
		"PhysicalAssetDefectDetails.GUIDPhysicalAssetDefect":
		{
			"Name": "GUIDPhysical Asset Defect",
			"Hash": "PhysicalAssetDefect-Edit-GUIDPhysicalAssetDefect",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAssetDefect-Edit-DataAudit",
				"Group": "PhysicalAssetDefect-Edit-DataAudit"
			}
		},
		"PhysicalAssetDefectDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "PhysicalAssetDefect-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAssetDefect-Edit-DataAudit",
				"Group": "PhysicalAssetDefect-Edit-DataAudit"
			}
		},
		"PhysicalAssetDefectDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "PhysicalAssetDefect-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAssetDefect-Edit-DataAudit",
				"Group": "PhysicalAssetDefect-Edit-DataAudit"
			}
		},
		"PhysicalAssetDefectDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "PhysicalAssetDefect-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAssetDefect-Edit-DataAudit",
				"Group": "PhysicalAssetDefect-Edit-DataAudit"
			}
		},
		"PhysicalAssetDefectDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "PhysicalAssetDefect-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAssetDefect-Edit-DataAudit",
				"Group": "PhysicalAssetDefect-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAssetDefect-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAssetDefect-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAssetDefect-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAssetDefect-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Condition State Descriptions",
			"Hash": "PhysicalAssetDefect-Edit-ConditionStates",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Condition State Descriptions",
					"Hash": "PhysicalAssetDefect-Edit-ConditionStates",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "PhysicalAssetDefect-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "PhysicalAssetDefect-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
